import { render, staticRenderFns } from "./PaymentIconButton.vue?vue&type=template&id=073b9b21"
import script from "./PaymentIconButton.vue?vue&type=script&lang=js"
export * from "./PaymentIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports